import { Dispatch } from "redux"
import IDispatcher from "../../../../../Util/IDispatcher"
import { ActionType } from "../../../Main/Filter/Actions/ActionTypes"
import HeaderDispatch from "./model"
import HeaderUI from "./HeaderUI"
import { connect } from "react-redux"
import { ActionType as BookmarkAction } from "../../../Main/Bookmark/Actions/ActionTypes"
import { ActionType as SeenAction } from "../../../Main/LastSeen/Actions/ActionTypes"
import { ActionType as AllMoshaveranAction } from "../../../Main/AllMoshaveran/Actions/ActionTypes"

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<HeaderDispatch> => ({
    dispatcher: {
        filter: () => {
            dispatch({
                type: ActionType.FILTER_IS_OPEN,
                isOpen: true
            })
        },
        bookmark : () => {
            dispatch({
                type: BookmarkAction.BOOKMARK_SHOW
            })
        },
        seen : () => {
            dispatch({
                type: SeenAction.SEEN_SHOW
            })
        },
        moshaveran : () => {
            dispatch({
                type: AllMoshaveranAction.ALL_MOSHAVERAN_SHOW
            })
        }
    }
})

export default connect(undefined, mapDispatchToProps)(HeaderUI)